"use client"
/* */
const table = "flow--list--table";
const isLoading = "flow--list--table--is-loading";
const row = "flow--list--table--row";
const isSelected = "flow--list--table--is-selected";
const hasAction = "flow--list--table--has-action";
const styles = {
	table: table,
	isLoading: isLoading,
	row: row,
	isSelected: isSelected,
	hasAction: hasAction
};

export { styles as default, hasAction, isLoading, isSelected, row, table };
//# sourceMappingURL=Table.module.css.mjs.map
